<template>
  <div class="flex items-center flex-wrap scrollable">
  </div>
</template>

<script>

export default {
};
</script>

<style lang="scss">
</style>
